import React from 'react';
import { t } from '../../utils/translations';

const SubjectModal = ({
  selectedSubject,
  showTodaySectionForm,
  showSectionSelection,
  todayTopic,
  todaySection,
  todaySections,
  loading,
  loadingSections,
  userLanguage,
  quizSource,
  quizQuestionCount,
  selectedQuizSectionIds,
  onClose,
  onAddTodaysSection,
  onSubmitTodaysSection,
  onLearnSection,
  onSelectSection,
  onGenerateQuiz,
  onQuizSourceChange,
  setQuizQuestionCount,
  setSelectedQuizSectionIds,
  setTodayTopic,
  setTodaySection,
  setShowTodaySectionForm,
  setShowSectionSelection
}) => {
  if (!selectedSubject) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content subject-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="subject-modal-header">
            <span className="subject-modal-emoji">{selectedSubject.emoji}</span>
            <h2>{selectedSubject.name}</h2>
          </div>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label={t('closeModal', userLanguage)}
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          <p className="subject-modal-description">{selectedSubject.description}</p>
          
          {showTodaySectionForm ? (
            <form onSubmit={onSubmitTodaysSection} className="today-section-form">
              <h3>{t('addTodaysSection', userLanguage)}</h3>
              <div className="form-group">
                <label htmlFor="today-topic">{t('enterTopic', userLanguage)}</label>
                <input
                  id="today-topic"
                  type="text"
                  value={todayTopic}
                  onChange={(e) => setTodayTopic(e.target.value)}
                  placeholder={t('enterTopic', userLanguage)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <label htmlFor="today-section">{t('enterSection', userLanguage)}</label>
                <textarea
                  id="today-section"
                  value={todaySection}
                  onChange={(e) => setTodaySection(e.target.value)}
                  placeholder={t('enterSection', userLanguage)}
                  rows={4}
                  required
                  disabled={loading}
                />
              </div>
              <div className="form-actions">
                <button type="button" onClick={() => setShowTodaySectionForm(false)} disabled={loading}>
                  {t('cancel', userLanguage)}
                </button>
                <button type="submit" disabled={loading || !todayTopic.trim() || !todaySection.trim()}>
                  {t('submit', userLanguage)}
                </button>
              </div>
            </form>
          ) : showSectionSelection ? (
            <div className="section-selection">
              <h3>{t('selectSection', userLanguage)}</h3>
              {loadingSections ? (
                <p>{t('loading', userLanguage)}</p>
              ) : todaySections.length === 0 ? (
                <div>
                  <p>{t('noSectionsFound', userLanguage)}</p>
                  <button
                    type="button"
                    onClick={() => {
                      setShowSectionSelection(false);
                      onAddTodaysSection();
                    }}
                    className="btn-primary"
                  >
                    {t('addTodaysSection', userLanguage)}
                  </button>
                </div>
              ) : (
                <div className="sections-list">
                  {todaySections.map((section) => (
                    <div key={section.id} className="section-item" onClick={() => onSelectSection(section)}>
                      <h4>{section.topic}</h4>
                      <p className="section-preview">{section.section_content.substring(0, 100)}...</p>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          onSelectSection(section);
                        }}
                        className="btn-primary"
                        disabled={loading}
                      >
                        {t('learnThis', userLanguage)}
                      </button>
                    </div>
                  ))}
                </div>
              )}
              <div className="form-actions">
                <button type="button" onClick={() => setShowSectionSelection(false)} disabled={loading}>
                  {t('back', userLanguage)}
                </button>
              </div>
            </div>
          ) : (
            <div className="subject-options">
              <button
                className="subject-option-btn"
                onClick={onAddTodaysSection}
                disabled={loading}
              >
                <span className="option-icon">📝</span>
                <div className="option-content">
                  <h3>{t('addTodaysSection', userLanguage)}</h3>
                  <p>{t('addTodaysSectionDesc', userLanguage)}</p>
                </div>
              </button>
              <button
                className="subject-option-btn"
                onClick={onLearnSection}
                disabled={loading}
              >
                <span className="option-icon">📚</span>
                <div className="option-content">
                  <h3>{t('learnSection', userLanguage)}</h3>
                  <p>{t('learnSectionDesc', userLanguage)}</p>
                </div>
              </button>
              <div className="subject-option-btn">
                <span className="option-icon">🎮</span>
                <div className="option-content">
                  <h3>{t('generateQuiz', userLanguage)}</h3>
                  <p>{t('generateQuizDesc', userLanguage)}</p>
                  <div className="form-group quiz-config-group">
                    <label htmlFor="quiz-source-select">
                      {t('quizSourceLabel', userLanguage)}
                    </label>
                    <select
                      className="quiz-config-select"
                      id="quiz-source-select"
                      value={quizSource}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => onQuizSourceChange(e.target.value)}
                      disabled={loading}
                    >
                      <option value="auto">{t('quizSourceAuto', userLanguage)}</option>
                      <option value="weak_topics">{t('quizSourceWeakTopics', userLanguage)}</option>
                      <option value="knowledge_topics">{t('quizSourceKnowledgeTopics', userLanguage)}</option>
                      <option value="today_sections">{t('quizSourceTodaySections', userLanguage)}</option>
                    </select>
                  </div>
                  <div className="form-group quiz-config-group">
                    <label htmlFor="quiz-question-count-select">
                      {t('quizQuestionCountLabel', userLanguage)}
                    </label>
                    <select
                      className="quiz-config-select"
                      id="quiz-question-count-select"
                      value={quizQuestionCount}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => setQuizQuestionCount(Number(e.target.value))}
                      disabled={loading}
                    >
                      {[3, 4, 5, 6, 7, 8, 9, 10].map((count) => (
                        <option key={count} value={count}>
                          {count}
                        </option>
                      ))}
                    </select>
                  </div>
                  {quizSource === 'today_sections' && (
                    <div className="form-group quiz-config-group">
                      <label>
                        {t('quizSectionsLabel', userLanguage)}
                      </label>
                      {loadingSections ? (
                        <p>{t('loading', userLanguage)}</p>
                      ) : todaySections.length === 0 ? (
                        <p>{t('noSectionsFound', userLanguage)}</p>
                      ) : (
                        <div className="quiz-sections-container">
                          {todaySections.map((section) => (
                            <button
                              type="button"
                              key={section.id}
                              className={`quiz-section-item-btn ${selectedQuizSectionIds.includes(section.id) ? 'selected' : ''}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                const isSelected = selectedQuizSectionIds.includes(section.id);
                                setSelectedQuizSectionIds((prev) => (
                                  isSelected
                                    ? prev.filter((id) => id !== section.id)
                                    : [...prev, section.id]
                                ));
                              }}
                              aria-pressed={selectedQuizSectionIds.includes(section.id)}
                            >
                              <span>
                                <strong>{section.topic}</strong>
                                <br />
                                <small>{section.section_content.substring(0, 80)}...</small>
                              </span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                  <div className="form-actions">
                    <button
                      type="button"
                      className="btn-primary"
                      onClick={onGenerateQuiz}
                      disabled={loading}
                    >
                      {t('generateQuiz', userLanguage)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubjectModal;

